import './tabs.scss';

import { getOffset, smoothScrollTo } from '../../js/helper';

class Tabs {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-tabs',
            categoryAttr: 'category',
            contentAttr: 'content',
            wrapperAttr: 'wrapper',
            tabsEntryAttr: 'entry',
            tabsLinkAttr: 'link',
            labelAttr: 'data-tabs-label',
            iconAttr: 'data-tabs-icon',
            categoryStartIndex: 0,
            contentStartIndex: 0,
            activeClassname: 'is--active',
            offset: 1,
            onTabChange: null,
            onCategoryChange: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$tabs = element;
        this.$categories = this.$tabs.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.categoryAttr + '"]');
        this.$contents = this.$tabs.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        this.$categoriesSelect = null;
        this.$tabsNavigationWrapper = null;
        this.$header = document.querySelector('[data-header="root"]');
        this.$wrapper = this.$tabs.closest('[' + this.settings.initAttr + '="' + this.settings.wrapperAttr + '"]');
        this.animated = true;

        if (this.$categories.length === 0) {
            console.error('no elements found with [' + this.settings.initAttr + '="' + this.settings.categoryAttr + '"]');
            return;
        }

        if (this.$contents.length === 0) {
            console.error('no elements found with [' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        }
    }

    initialize () {
        if (this.$categories.length > 1 || this.$contents.length > 1) {
            this.$tabsNavigationWrapper = document.createElement('aside');
            this.$tabsNavigationWrapper.classList.add('tabs__navigation');
            this.$tabs.prepend(this.$tabsNavigationWrapper);
        }

        if (this.$categories.length > 1) {
            this.$categoriesSelect = this.buildCategorySelect();

            import('./../../components/form/form-input').then(({ FormInput }) => {
                const $inputWrapper = this.$categoriesSelect.closest('.select');

                const formAPI = new FormInput($inputWrapper);
                $inputWrapper.API = formAPI;
            });
        }

        let showIndex = 0;
        if (this.settings.categoryStartIndex < this.$categories.length) {
            showIndex = this.settings.categoryStartIndex;
        }
        this.setActiveCategory(this.$categories[showIndex], false);

        for (let i = 0; i < this.$categories.length; i++) {
            const $category = this.$categories[i];

            if (i === showIndex) {
                this.buildTabsNavigation($category, true);
            } else {
                this.buildTabsNavigation($category, false);
            }
        }

        if (this.$tabsNavigationWrapper !== null) {
            this.$tabsNavigation = this.$tabsNavigationWrapper.querySelectorAll('[' + this.settings.initAttr + '="nav"]');

            if (this.$tabsNavigation.length > 0) {
                this.setActiveNavigation(this.$tabsNavigation[showIndex]);
            } else {
                this.setActiveNavigation();
            }
        }

        if (this.$wrapper.previousElementSibling.getAttribute(this.settings.initAttr) === this.settings.tabsEntryAttr) {
            this.$tabsEntry = this.$wrapper.previousElementSibling;
            this.$tabsEntryLinks = this.$tabsEntry.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.tabsLinkAttr + '"]');

            for (let i = 0; i < this.$tabsEntryLinks.length; i++) {
                const $link = this.$tabsEntryLinks[i];

                $link.addEventListener('click', (e) => {
                    const indexer = parseInt($link.getAttribute('rel'));

                    this.$tabsEntry.classList.add('is--chosen');

                    const apiCheckInterval = window.setInterval(() => {
                        if (typeof this.$categoriesSelect.API !== 'undefined') {
                            clearInterval(apiCheckInterval);

                            const selectBox = this.$categoriesSelect.API;
                            selectBox.setValue(indexer);
                        }
                    }, 100);

                    /*
                    window.setTimeout(() => {
                        this.$categoriesSelect.selectedIndex = indexer;
                        this.$categoriesSelect.dispatchEvent(new Event('change'));
                    }, 250);
                    */

                    window.setTimeout(() => {
                        this.$header.classList.add('is--hidden');
                    }, 500);

                    e.preventDefault();
                });
            }
        }

        this.setEvents();
    }

    setEvents () {
        if (this.$categoriesSelect !== null) {
            this.$categoriesSelect.addEventListener('change', () => {
                const currentIndex = this.$categoriesSelect.value;

                this.setActiveCategory(this.$categories[currentIndex], true, this.animated);
                if (this.$tabsNavigation.length > 0) {
                    this.setActiveNavigation(this.$tabsNavigation[currentIndex]);
                } else {
                    this.setActiveNavigation();
                }
            });
        }
    }

    buildCategorySelect () {
        const $formElement = document.createElement('div');
        $formElement.classList.add('form__element');

        const $formSelect = document.createElement('div');
        $formSelect.classList.add('select');

        const $select = document.createElement('select');

        /*
        const $emptyOption = document.createElement('option');
        $select.appendChild($emptyOption);
        */

        for (let i = 0; i < this.$categories.length; i++) {
            const $category = this.$categories[i];
            const $option = document.createElement('option');
            const label = $category.getAttribute(this.settings.labelAttr);

            if (label === null) {
                console.error('category has no label in ' + this.settings.labelAttr);
                return;
            }

            $option.innerText = label;
            $option.setAttribute('value', i);
            $select.appendChild($option);
        }

        $formSelect.appendChild($select);

        const labelText = this.$tabs.getAttribute(this.settings.labelAttr);
        if (labelText !== null) {
            $select.setAttribute('placeholder', labelText);
        }

        $formElement.appendChild($formSelect);

        this.$tabsNavigationWrapper.appendChild($formElement);

        return $select;
    }

    buildTabsNavigation ($category, setActive) {
        const $contents = $category.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');

        let showIndex = 0;
        if (setActive === true) {
            if (this.settings.contentStartIndex < $contents.length) {
                showIndex = this.settings.contentStartIndex;
            }
            this.setActiveContent($contents[showIndex]);
        }

        const $tabsNavigation = document.createElement('nav');
        $tabsNavigation.classList.add('tabs__nav');
        $tabsNavigation.setAttribute(this.settings.initAttr, 'nav');

        if ($contents.length > 1) {
            const $tabsNavigationList = document.createElement('ul');

            for (let i = 0; i < $contents.length; i++) {
                const $content = $contents[i];
                const $item = document.createElement('a');
                $item.setAttribute('role', 'button');
                $item.classList.add('tabs__nav-item');

                if (i === showIndex) {
                    $item.classList.add('is--active');
                }

                const label = $content.getAttribute(this.settings.labelAttr);

                if (label === null) {
                    console.error('content has no label in ' + this.settings.labelAttr);
                    return;
                }

                $item.innerText = label;
                $item.setAttribute('rel', i);

                const iconPath = $content.getAttribute(this.settings.iconAttr);

                if (iconPath !== null) {
                    const $icon = document.createElement('span');
                    $icon.classList.add('icon');
                    $icon.style.backgroundImage = 'url("' + iconPath + '")';
                    $item.appendChild($icon);
                }
                const $listItem = document.createElement('li');
                $listItem.appendChild($item);
                $tabsNavigationList.appendChild($listItem);
            }

            $tabsNavigationList.addEventListener('click', (e) => {
                if (e.target.tagName.toLowerCase() === 'a') {
                    const $currentActive = $tabsNavigationList.querySelector('.is--active');
                    const $newActive = e.target;

                    if ($currentActive !== null) {
                        $currentActive.classList.remove('is--active');
                    }

                    $newActive.classList.add('is--active');
                    $tabsNavigation.scrollLeft = $newActive.offsetLeft;
                    const contentIndex = $newActive.getAttribute('rel');
                    this.setActiveContent($contents[contentIndex], true);
                }
            });

            $tabsNavigation.appendChild($tabsNavigationList);
        }

        this.$tabsNavigationWrapper.appendChild($tabsNavigation);
    }

    setActiveCategory ($category, showContent, animate) {
        for (let i = 0; i < this.$categories.length; i++) {
            this.$categories[i].classList.remove(this.settings.activeClassname);
        }
        $category.classList.add(this.settings.activeClassname);
        this.$currentCategory = $category;

        if (showContent !== false) {
            const $content = $category.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
            this.setActiveContent($content[0]);

            if (this.$tabsNavigation.length > 0) {
                this.setActiveNavigation(this.$tabsNavigation[0]);
            }

            if (animate === true) {
                const position = getOffset(this.$tabs);
                let offset = this.settings.offset;

                if (this.$header !== null) {
                    offset = this.$header.offsetHeight;
                }
                smoothScrollTo(0, position.top - offset, 250);
            }
        }

        if (typeof this.settings.onCategoryChange === 'function') {
            this.settings.onCategoryChange($category);
        }
    }

    setActiveContent ($content, jump) {
        for (let i = 0; i < this.$contents.length; i++) {
            this.$contents[i].classList.remove(this.settings.activeClassname);
        }
        $content.classList.add(this.settings.activeClassname);
        this.$currentContent = $content;

        if (jump === true) {
            const position = getOffset(this.$tabs);

            let offset = this.settings.offset;

            if (this.$header !== null) {
                offset = this.$header.offsetHeight;
            }

            smoothScrollTo(0, position.top - offset, 250);
        }

        if (typeof this.settings.onTabChange === 'function') {
            this.settings.onTabChange($content);
        }
    }

    setActiveNavigation ($nav) {
        for (let i = 0; i < this.$tabsNavigation.length; i++) {
            this.$tabsNavigation[i].classList.remove(this.settings.activeClassname);
        }

        if ($nav && typeof $nav !== 'undefined' && $nav !== null) {
            $nav.classList.add(this.settings.activeClassname);

            const $active = $nav.querySelector('.is--active');

            if ($active !== null) {
                $active.classList.remove('is--active');
            }

            if ($nav.querySelector('a[rel="0"]') !== null) {
                $nav.querySelector('a[rel="0"]').classList.add('is--active');
            }

            this.$currentNavigation = $nav;
        }
    }
}

export { Tabs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $tabs = $context.querySelectorAll('[data-tabs="root"]');

        if ($tabs.length > 0) {
            for (let i = 0; i < $tabs.length; i++) {
                const $tab = new Tabs($tabs[i], {
                    onTabChange: ($tabContent) => {
                        if ($tabs[i].closest('.tabs').classList.contains('is--visible')) {
                            const $animations = $tabContent.querySelectorAll('[data-lottie]');

                            for (let i = 0; i < $animations.length; i++) {
                                const $animation = $animations[i];
                                const animationAPI = $animation.API;

                                animationAPI.goToAndStop(0);
                                animationAPI.play();
                            }
                        }
                    }
                });
                $tab.initialize();
            }
        }
    }
});
